<form [formGroup]="selectForm">
  <div class="app-form-loader">
    <mat-form-field
      [appearance]="appearance()"
      subscriptSizing="dynamic"
      class="custom-select-panel"
    >
      <mat-select
        formControlName="selectedForm"
        i18n-placeholder
        placeholder="Select form"
        (selectionChange)="formSelectionChange($event.value)"
      >
        @for (templ of loadedTemplates(); track templ.uuid) {
          <mat-option [value]="templ.uuid" class="custom-select-panel">
            {{ templ.title }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (!loadOnSelectionChange()) {
      <button
        matButton="filled"
        color="accent"
        (click)="loadForm()"
        [disabled]="!selectForm.valid || formLoaded()"
        i18n
      >
        Load Form
      </button>
      <button
        matButton="elevated"
        type="button"
        (click)="clearRefresh()"
        class="app-panel-button-old"
        i18n
      >
        Clear and Refresh
      </button>
    }
  </div>
</form>
